import { Link } from "react-router-dom";

const Section = ({ n, title, children }) => (
  <section className="mt-12 first:mt-0">
    <div className="flex items-baseline gap-4">
      <span className="font-mono-x text-xs tracking-widest text-[var(--tha-red)] shrink-0">
        ART. {String(n).padStart(2, "0")}
      </span>
      <h2 className="font-display text-2xl sm:text-3xl text-white leading-tight">
        {title}
      </h2>
    </div>
    <div className="mt-4 space-y-3 text-sm text-[var(--tha-muted)] leading-relaxed">
      {children}
    </div>
  </section>
);

const Voorwaarden = () => (
  <div data-testid="voorwaarden-page" className="py-20">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <div className="flex items-center gap-3">
        <span className="h-px w-12 bg-[var(--tha-red)]" />
        <span className="text-xs font-mono-x tracking-[0.3em] text-[var(--tha-red)]">
          DE KLEINE LETTERTJES — RECHTSGELDIG
        </span>
      </div>
      <h1 className="font-display text-5xl sm:text-7xl mt-6 leading-none">
        ALGEMENE <span className="neon-red-text">VOORWAARDEN.</span>
      </h1>
      <p className="mt-6 text-sm text-[var(--tha-muted)] max-w-2xl">
        Versie 1.0 — laatste update: 13 februari 2026. Deze algemene voorwaarden
        zijn van toepassing op alle aanbiedingen, overeenkomsten en leveringen
        van Tik Hem Aan! (KvK 42065864). Door een bestelling te plaatsen ga je
        uitdrukkelijk akkoord met deze voorwaarden. Vragen of klachten? Mail{" "}
        <a href="mailto:tikhemaannl@gmail.com" className="text-[var(--tha-red)] underline">
          tikhemaannl@gmail.com
        </a>
        .
      </p>

      <Section n={1} title="DEFINITIES">
        <p>In deze voorwaarden wordt verstaan onder:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><span className="text-white">Tik Hem Aan! / wij / ons</span>: de eenmanszaak Tik Hem Aan!, ingeschreven bij de Kamer van Koophandel onder nummer 42065864, gevestigd in Nederland;</li>
          <li><span className="text-white">Consument / klant / jij</span>: de natuurlijke persoon van 18 jaar of ouder die niet handelt in de uitoefening van beroep of bedrijf en een overeenkomst aangaat met Tik Hem Aan!;</li>
          <li><span className="text-white">Producten</span>: de alcoholhoudende dranken (mini-shots) en aanverwante artikelen die wij via de webshop aanbieden;</li>
          <li><span className="text-white">Overeenkomst</span>: iedere overeenkomst tussen Tik Hem Aan! en de consument met betrekking tot de koop van producten;</li>
          <li><span className="text-white">Webshop</span>: de website tikhemaanshot.nl en eventuele subdomeinen.</li>
        </ul>
      </Section>

      <Section n={2} title="IDENTITEIT ONDERNEMER">
        <p>
          <span className="text-white">Tik Hem Aan!</span>
          <br />Eenmanszaak — Nederland
          <br />KvK-nummer: <span className="text-white">42065864</span>
          <br />E-mail: <a href="mailto:tikhemaannl@gmail.com" className="text-[var(--tha-red)] underline">tikhemaannl@gmail.com</a>
        </p>
      </Section>

      <Section n={3} title="LEEFTIJDSGRENS — NIX18">
        <p>
          Wij verkopen géén alcoholhoudende producten aan personen die jonger zijn
          dan 18 jaar. Dit is wettelijk verplicht onder artikel 20 van de
          Nederlandse Alcoholwet. Per bestelling verklaart de consument
          uitdrukkelijk 18 jaar of ouder te zijn.
        </p>
        <p>
          Bij aflevering kan de bezorger om een geldig legitimatiebewijs
          (paspoort, rijbewijs of identiteitskaart) vragen. Bij twijfel,
          weigering of het ontbreken van legitimatie wordt de bestelling
          retour gestuurd en het aankoopbedrag, minus verzendkosten,
          teruggestort.
        </p>
        <p>
          Het verstrekken van valse informatie over je leeftijd is strafbaar.
          We behouden ons het recht voor om aangifte te doen bij overtreding.
        </p>
      </Section>

      <Section n={4} title="TOEPASSELIJKHEID">
        <p>
          Deze voorwaarden zijn van toepassing op elk aanbod en op alle
          overeenkomsten tussen Tik Hem Aan! en de consument. Voordat een
          overeenkomst wordt gesloten, wordt de tekst van deze voorwaarden
          beschikbaar gesteld via de webshop en kan deze worden opgeslagen of
          afgedrukt. Afwijkingen van deze voorwaarden zijn alleen geldig
          indien deze schriftelijk zijn overeengekomen.
        </p>
      </Section>

      <Section n={5} title="HET AANBOD">
        <p>
          Alle aanbiedingen op de webshop zijn vrijblijvend. Het aanbod bevat
          een volledige en nauwkeurige omschrijving van het product, inclusief
          alcoholpercentage, inhoud en samenstelling. Kennelijke vergissingen
          of fouten in het aanbod binden ons niet. Afbeeldingen kunnen kleine
          afwijkingen vertonen ten opzichte van het werkelijke product.
        </p>
        <p>
          Onder de Nederlandse Alcoholwet (geldig sinds 1 juli 2021) mogen
          alcoholhoudende dranken niet worden aangeboden met een korting van
          meer dan <span className="text-white">25%</span>. Wij handhaven deze
          regel strikt in al onze kortingscodes en aanbiedingen.
        </p>
      </Section>

      <Section n={6} title="DE OVEREENKOMST">
        <p>
          De overeenkomst komt tot stand op het moment dat de consument:
        </p>
        <ol className="list-decimal pl-5 space-y-1">
          <li>de bestelling heeft geplaatst via de webshop;</li>
          <li>uitdrukkelijk heeft bevestigd 18 jaar of ouder te zijn;</li>
          <li>akkoord is gegaan met deze voorwaarden en de privacyverklaring;</li>
          <li>de betaling succesvol heeft afgerond via onze betaalpartner Mollie B.V.</li>
        </ol>
        <p>
          De consument ontvangt direct na betaling een bevestiging per
          e-mail met daarin de bestelgegevens en het ordernummer.
        </p>
      </Section>

      <Section n={7} title="PRIJZEN EN BTW">
        <p>
          Alle vermelde prijzen zijn in euro's en inclusief 21% BTW. De
          verzendkosten worden apart in beeld gebracht tijdens het
          afrekenen. Prijzen kunnen tussentijds wijzigen; voor reeds
          geplaatste bestellingen geldt de op dat moment overeengekomen
          prijs.
        </p>
      </Section>

      <Section n={8} title="BETALING">
        <p>
          Betalingen worden verwerkt door{" "}
          <span className="text-white">Mollie B.V.</span> (KvK 30204462),
          een door De Nederlandsche Bank gereguleerde betaalinstelling.
          Tik Hem Aan! ontvangt en bewaart géén kaartgegevens of
          bankgegevens — die worden uitsluitend door Mollie verwerkt
          conform PCI-DSS-standaarden.
        </p>
        <p>Beschikbare betaalmethoden zijn onder andere: iDEAL, Bancontact en creditcard. De volledige lijst zie je tijdens het afrekenen.</p>
        <p>
          Bij niet (volledig) of niet tijdige betaling is de consument
          van rechtswege in verzuim. Wij zijn dan gerechtigd de
          overeenkomst te ontbinden of de levering op te schorten.
        </p>
      </Section>

      <Section n={9} title="LEVERING EN UITVOERING">
        <p>
          Wij versturen onze producten binnen Nederland via DHL.
          Aflevertijd is doorgaans 2 tot 5 werkdagen nadat de betaling
          door ons is ontvangen. De maximale levertermijn is, conform
          artikel 7:46f BW, 30 dagen.
        </p>
        <p>
          Als de levering vertraging ondervindt, of een bestelling
          niet of slechts gedeeltelijk kan worden uitgevoerd, ontvangt de
          consument hiervan zo snel mogelijk bericht. De consument heeft
          in dat geval het recht om de overeenkomst zonder kosten te
          ontbinden.
        </p>
        <p>
          Het risico van beschadiging en/of vermissing van producten
          berust bij Tik Hem Aan! tot het moment van bezorging aan de
          consument.
        </p>
      </Section>

      <Section n={10} title="HERROEPINGSRECHT">
        <p>
          De consument heeft op grond van artikel 6:230o BW het recht om
          binnen <span className="text-white">14 dagen</span> na ontvangst
          van het product de overeenkomst zonder opgaaf van reden te
          ontbinden.
        </p>
        <p className="text-white">
          Uitzondering: dit herroepingsrecht is niet van toepassing op
          producten die om redenen van hygiëne of gezondheidsbescherming
          niet geschikt zijn om te worden teruggezonden en waarvan de
          verzegeling na levering is verbroken (art. 6:230p sub g BW).
          Geopende flesjes kunnen daarom niet worden geretourneerd.
        </p>
        <p>
          Ongeopende en onbeschadigde flesjes kunnen binnen 14 dagen
          worden geretourneerd op kosten van de consument. Stuur eerst
          een e-mail naar tikhemaannl@gmail.com voor het retouradres en
          de procedure. Het modelformulier voor herroeping kun je{" "}
          <a
            href="https://www.consuwijzer.nl/sites/default/files/migration/modelformulier_voor_herroeping_0.pdf"
            target="_blank"
            rel="noreferrer"
            className="text-[var(--tha-red)] underline"
          >
            hier downloaden (ConsuWijzer)
          </a>
          .
        </p>
        <p>
          Bij correct uitgevoerde herroeping wordt het aankoopbedrag,
          inclusief de oorspronkelijke verzendkosten naar de consument,
          binnen 14 dagen na ontvangst van de retourzending terugbetaald
          via dezelfde betaalmethode.
        </p>
      </Section>

      <Section n={11} title="CONFORMITEIT EN GARANTIE">
        <p>
          Tik Hem Aan! staat ervoor in dat de producten voldoen aan de
          overeenkomst, de in het aanbod vermelde specificaties en aan
          de redelijke eisen van deugdelijkheid en bruikbaarheid (art.
          7:17 BW). Klachten over geleverde producten dienen binnen
          redelijke termijn na ontdekking, doch uiterlijk binnen twee
          maanden, schriftelijk en gemotiveerd bij ons te worden
          ingediend.
        </p>
      </Section>

      <Section n={12} title="VOORRAAD EN RESERVERING">
        <p>
          Producten worden verkocht op basis van beschikbaarheid. Bij
          het afrekenen wordt de voorraad gedurende
          <span className="text-white"> 10 minuten</span> voor de
          consument gereserveerd om de betaling af te ronden. Wordt de
          betaling niet binnen deze periode voltooid, dan vervalt de
          reservering automatisch en komt de voorraad weer beschikbaar
          voor andere klanten.
        </p>
      </Section>

      <Section n={13} title="VERANTWOORD ALCOHOLGEBRUIK">
        <p>
          Alcohol is een genotsmiddel met risico's voor de gezondheid.
          Wij moedigen verantwoord alcoholgebruik nadrukkelijk aan:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>schenk nooit aan personen onder de 18 jaar;</li>
          <li>drink niet tijdens zwangerschap of borstvoeding;</li>
          <li>combineer alcohol niet met medicijnen of drugs;</li>
          <li>drink niet als je nog moet rijden — 0,5‰ is wettelijk de bovengrens, voor beginnende bestuurders 0,2‰;</li>
          <li>volg de richtlijn van de Gezondheidsraad: geen of maximaal één glas per dag.</li>
        </ul>
        <p>
          Meer informatie of hulp nodig?{" "}
          <a
            href="https://www.alcoholinfo.nl"
            target="_blank"
            rel="noreferrer"
            className="text-[var(--tha-red)] underline"
          >
            alcoholinfo.nl
          </a>
          {" "}of bel de Alcohollijn op 0900-1995.
        </p>
      </Section>

      <Section n={14} title="OVERMACHT">
        <p>
          Tik Hem Aan! is niet aansprakelijk indien zij door overmacht
          niet aan haar verplichtingen kan voldoen. Onder overmacht
          wordt onder meer verstaan: storingen in de levering door
          leveranciers, stakingen, transportproblemen, brand,
          natuurrampen, pandemieën en overheidsmaatregelen.
        </p>
      </Section>

      <Section n={15} title="AANSPRAKELIJKHEID">
        <p>
          Onze aansprakelijkheid voor indirecte schade is uitgesloten.
          Onze totale aansprakelijkheid is in alle gevallen beperkt tot
          het aankoopbedrag van het product waar de klacht betrekking
          op heeft. Niets in deze bepaling beperkt aansprakelijkheid
          voor opzet, grove schuld of dwingend recht.
        </p>
      </Section>

      <Section n={16} title="PRIVACY">
        <p>
          De manier waarop wij omgaan met je persoonsgegevens lees je
          in onze{" "}
          <Link to="/privacy" className="text-[var(--tha-red)] underline">
            privacyverklaring
          </Link>
          . Wij voldoen aan de Algemene Verordening Gegevensbescherming
          (AVG/GDPR).
        </p>
      </Section>

      <Section n={17} title="KLACHTENREGELING">
        <p>
          Klachten kun je binnen redelijke termijn en in elk geval
          binnen 7 dagen na ontdekking schriftelijk indienen via{" "}
          <a href="mailto:tikhemaannl@gmail.com" className="text-[var(--tha-red)] underline">
            tikhemaannl@gmail.com
          </a>
          . Wij streven ernaar binnen 14 dagen inhoudelijk te reageren.
        </p>
        <p>
          Komen we er samen niet uit, dan kan de consument het geschil
          voorleggen aan de Geschillencommissie via{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noreferrer"
            className="text-[var(--tha-red)] underline"
          >
            ec.europa.eu/consumers/odr
          </a>{" "}
          (Europees ODR-platform).
        </p>
      </Section>

      <Section n={18} title="TOEPASSELIJK RECHT EN GESCHILLEN">
        <p>
          Op alle overeenkomsten tussen Tik Hem Aan! en de consument is
          uitsluitend Nederlands recht van toepassing, ook indien aan
          een verbintenis geheel of gedeeltelijk in het buitenland
          uitvoering wordt gegeven. Geschillen worden voorgelegd aan de
          bevoegde Nederlandse rechter.
        </p>
      </Section>

      <Section n={19} title="WIJZIGINGEN">
        <p>
          Tik Hem Aan! behoudt zich het recht voor deze voorwaarden te
          wijzigen. De op het moment van de bestelling geldende versie
          is van toepassing. Wijzigingen worden bekendgemaakt op deze
          pagina, met vermelding van de datum waarop ze van kracht
          worden.
        </p>
      </Section>

      <div className="mt-16 pt-8 border-t border-[var(--tha-border)] text-xs font-mono-x tracking-widest text-[var(--tha-dim)]">
        KVK 42065864 — NIX18 — GENIET, MAAR DRINK MET MATE
      </div>
    </div>
  </div>
);

export default Voorwaarden;
